import BlackBird from './lib'
export type { Routes } from './lib'
export { blackBirdFactory } from './lib'
export type { BlackBirdOptions, BlackbirdType, BlackBirdUrl } from './lib/blackbird'
export { BlackBird }
export default BlackBird
